import { realtime } from '../api/realtime.js';

// Subscribe a scene to incoming social events. Shows a toast on friend request /
// acceptance and bumps a badge counter. Auto-detaches on scene shutdown.
export function attachSocialNotifications(scene, { onToast, onBadge } = {}) {
  const offs = [];
  offs.push(realtime.on('friend_request', (m) => {
    onToast?.(`${m.from.name} chce być znajomym!`);
    onBadge?.(+1);
  }));
  offs.push(realtime.on('fuel_gift', (m) => {
    onToast?.(`${m.from.name} przysłał(a) Ci kanister {fuel}`);
  }));
  offs.push(realtime.on('friend_accepted', (m) => {
    onToast?.(`${m.by.name} przyjął(a) zaproszenie {party}`);
  }));
  scene.events.once('shutdown', () => offs.forEach(off => off()));
}
